<app-page-header [pageTitle]="title"></app-page-header>

<app-bar-chart [dataSource]="carsData" [availableWidth]="windowWidth"></app-bar-chart>

<button (click)="addCar()">Add data point</button> |
<button (click)="popCar()">Remove data point</button>

<app-bar-chart-table [dataSource]="carsData"></app-bar-chart-table>
